import * as React from "react"

import { GenerateRefsOptions, RefType } from "shared/hubrise/utils/ref"

import Modal from "./Modal"

export const useGenerateRefs = (refType: RefType, onGenerate: (options: GenerateRefsOptions) => void) => {
  const [open, setOpen] = React.useState(false)

  const modal = open ? (
    <Modal refType={refType} onSubmit={(options) => onGenerate(options)} close={() => setOpen(false)} />
  ) : undefined

  return {
    generateRefsModal: modal,
    openGenerateRefs: () => setOpen(true),
  }
}
